var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"mb-4"},[_c('h1',[_vm._v(_vm._s(_vm.__('Kundengruppe erstellen')))])]),_vm._v(" "),_c('div',{},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.form.post(_vm.route('admin.customer-groups.store'))}}},[_c('form-fields',{attrs:{"form":_vm.form}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }